import { render, staticRenderFns } from "./VipServiceIndexView.vue?vue&type=template&id=2b93cc24&scoped=true"
import script from "./VipServiceIndexView.vue?vue&type=script&lang=js"
export * from "./VipServiceIndexView.vue?vue&type=script&lang=js"
import style0 from "./VipServiceIndexView.vue?vue&type=style&index=0&id=2b93cc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93cc24",
  null
  
)

export default component.exports